module.exports = __webpack_public_path__ + "images/emoji/honeybee.5c9d6132112f0110044f.png";